export const MOBILE = 'MOBILE';
export const QUESTION_ID_MAP = {
	EVENT_NAME: '6',
	START_DATE: '7',
	TIME: '8',
	LOCATION: '9',
	DESCRIPTION: '10',
	END_DATE: '28'
};
